import React, { useState, useEffect, useContext, useRef } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { GrClose } from "react-icons/gr";
import axios from "axios";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import ProductCellOrder from './ProductCellOrder';
import EditQuotation from './EditQuotation';
import { MemoryRouter, Route } from 'react-router-dom';

export default function AnimatedModal({
    show,
    handleClose,
    id,
    numero_orden,
    usuario,
    cliente,
    proveedor,
    categoria,
    monto_total,
    estado,
    fecha_entrega,
    observaciones,
    motivo_no_asignacion,
    delay,
    onDataChange, 
    from
}) {    
    const refObs = useRef(null);
    const [statusMotive] = useState(motivo_no_asignacion);
    const [statusObs, setStatusObs] = useState(observaciones);
    const [status_item, setStatusItem] = useState([]);
    const [files, setFiles] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isEditing, setIsEditing] = useState(false); 

    function traerItemStatus() {
        var xmlhttp1 = new XMLHttpRequest();
        xmlhttp1.onreadystatechange = function () {
            if (xmlhttp1.readyState === 4) {
                if (xmlhttp1.status === 200) {
                    try {
                        let respuesta1 = JSON.parse(xmlhttp1.responseText);
                        if (Array.isArray(respuesta1.items)) {
                            setStatusItem(respuesta1.items.slice().reverse());
                        } else {
                            setStatusItem([]);
                        }
                    } catch (error) {
                        setStatusItem([]);
                    }
                } else {
                    setStatusItem([]);
                }
            }
        };
        var cadenaParametros = `ID=${encodeURIComponent(id)}`;
        xmlhttp1.open('POST', `${process.env.REACT_APP_API_BASE||"http://localhost/twinpack/php"}/buscar_orden_status.php`, true);
        // xmlhttp1.open('POST', 'http://localhost/pruebaTwinpack/php/buscar_orden_status.php', true);
        xmlhttp1.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xmlhttp1.send(cadenaParametros);
        console.log("cadenaParametros", cadenaParametros);
    }

    useEffect(() => {
        if (show) {
            traerItemStatus();
            traerArchivos();
        }
        setTimeout(() => {
            if (refObs.current) {
                refObs.current.style.height = "5px";
                let new_height = refObs.current.scrollHeight + 10;
                refObs.current.style.height = `${new_height}px`;
            }
        }, 200);
    }, [show]);
    const traerArchivos = () => {
        const params = new URLSearchParams({ ID: id }).toString();
        axios.post(`${process.env.REACT_APP_API_BASE||"http://localhost/twinpack/php"}/buscar_archivos.php`, params)
//        axios.post('http://localhost/pruebaTwinpack/php/buscar_archivos.php', params)
            .then(response => {
                if (response.data && Array.isArray(response.data.files)) {
                    setFiles(response.data.files);
                } else {
                    setFiles([]);
                }
            })
            .catch(error => {
                setFiles([]);
            });
    };

    const onChangeDate = (e, index) => {
        let status_item_new = [...status_item];
        status_item_new[index].created = e.target.value;
        setStatusItem(status_item_new);
    
        const data = new FormData();
        data.append('ID', id);
        data.append('StatusItems', JSON.stringify(status_item_new));
        console.log("status_item_new", status_item_new);
        // Verificar si el estado es "Orden NO Asignada"
        if (status_item[index]?.status === "Orden NO Asignada") {
            const motivo = prompt("Ingresa el motivo de no asignación:");
            if (motivo) {
                data.append('MotivoNoAsignacion', motivo);
                console.log("Motivo de no asignación:", motivo);
            }
        }
        axios.post(`${process.env.REACT_APP_API_BASE||"http://localhost/twinpack/php"}/guardar_estados_todos.php`, data)
        //        axios.post('http://localhost/pruebaTwinpack/php/guardar_estados_todos.php', data)
            .then(response => {
                if (response.data.logs) {
                    response.data.logs.forEach(log => console.log(log));
                }
            })
            .catch(error => {
                console.error("Error al enviar datos al backend:", error);
                toast.error("Error al guardar los cambios");
            });
    };

    const handleCircleClick = (index) => {
        setSelectedItem(selectedItem === index ? null : index);
    };
    
    const handleCloseAndReload = () => {
        handleClose();
        if(typeof onDataChange === 'function') {
            onDataChange();
        }
    };

    const handleDeleteFile = async (file) => {
        const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este archivo?");
        if (confirmDelete) {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_BASE||"http://localhost/twinpack/php"}/eliminar_file.php`,
//                    'http://localhost/pruebaTwinpack/php/eliminar_file.php',
                    new URLSearchParams({ nombre: file.nombre, origen: file.origen })
                );
                if (response.data.message === "Archivo eliminado correctamente") {
                    setFiles((prevFiles) => prevFiles.filter((f) => f.nombre !== file.nombre));
                    toast.success("Archivo eliminado correctamente");
                } else {
                    console.error("Error al eliminar el archivo");
                    toast.error("Error al eliminar el archivo");
                }
            } catch (error) {
                console.error("Error al eliminar el archivo:", error);
                toast.error("Error al eliminar el archivo");
            }
        }
    };

    const handleEdit = () => {
    setIsEditing(true);
    };

const handleDelete = async () => {
    const confirmDelete = window.confirm(`¿Estás seguro de que deseas eliminar la orden ${id}?`);
    if (confirmDelete) {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE||"http://localhost/twinpack/php"}/eliminar_orden.php`, new URLSearchParams({ id }));
//            const response = await axios.post('http://localhost/pruebaTwinpack/php/eliminar_orden.php', new URLSearchParams({ id }));
            if (response.data.status === "success") {
                toast.success(`Orden ${id} eliminada correctamente`);
                handleClose();
            if (onDataChange) onDataChange();
            } else {
                toast.error("Error al eliminar la orden");
            }
        } catch (error) {
            console.error("Error al eliminar la orden:", error);
            toast.error("Error al eliminar la orden");
        }
    }
};
    const order = [
        "Cotizado",
        "Orden de Compra Emitida",
        "Proceso de Diseño y Desarrollo",
        "Producción",
        "Entregado",
        "Orden NO Asignada"
    ];

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal"
            open={show}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={show}>
                <div className="paper">
                    <GrClose className="modal_image_close" onClick={handleCloseAndReload} />
                        {isEditing ? (
                            <MemoryRouter initialEntries={[{
                                pathname: `/editar-cotizacion/${id}`,
                                state: {
                                    from: "CalendarDash",
                                    numero_orden,
                                    usuario,
                                    cliente,
                                    proveedor,
                                    categoria,
                                    monto_total,
                                    estado,
                                    fecha_entrega,
                                    observaciones,
                                    motivo_no_asignacion,
                                    delay,
                                }
                            }]}>
                                <Route path="/editar-cotizacion/:orderId">
                                    <EditQuotation onCloseEdit={() => { 
                                        setIsEditing(false);
                                        if(typeof onDataChange === 'function') {
                                            onDataChange();
                                        }
                                        handleClose();
                                    }} />
                                </Route>
                            </MemoryRouter>
                            ) : (
                        <>
                            <h2>Número de Solicitud: {numero_orden}</h2>
                            <div className="stepper">
                                {order.map((item, index) => (
                                    <div key={index} className="step">
                                        <div
                                            className="circle"
                                            style={{
                                                background:
                                                    selectedItem === index
                                                        ? '#9f0059'
                                                        : !!status_item[index]?.created
                                                        ? '#9f0059'
                                                        : 'white',
                                            }}
                                            onClick={() => handleCircleClick(index)}
                                        ></div>
                                        <label className="label">{item}</label>
                                        {selectedItem === index && (
                                            <input
                                                type="date"
                                                style={{
                                                    border: "solid 1px",
                                                    background: "white",
                                                    borderRadius: "5px",
                                                    width: "100px",
                                                }}
                                                autoComplete="none"
                                                className="label_status pp_status_date"
                                                value={status_item[index]?.created || ''}
                                                onChange={(e) => onChangeDate(e, index)}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
    
                            <div className="content_row">
                                <div className="observaciones_div">
                                    <p>Observaciones:</p>
                                    <textarea
                                        ref={refObs}
                                        value={statusObs}
                                        autoComplete="none"
                                        className="label_status pp_status_obs"
                                        onChange={(e) => setStatusObs(e.target.value)}
                                        readOnly
                                    />
                                </div>
                                <div className="archivos_div">
                                    <p>Archivos:</p>
                                    <div className="files">
                                        {files.length > 0 ? (
                                            files.map((file) => (
                                                <div key={file.nombre} className="file">
                                                    <a
                                                        target="_blank"
                                                        href={`http://localhost/twinpack/php/uploads/${file.nombre}`}
                                                        rel="noopener noreferrer"
                                                    >
                                                        <p className="name">{file.nombre}</p>
                                                    </a>
                                                    <MdDelete
                                                        className="delete-file-icon"
                                                        onClick={() => handleDeleteFile(file)}
                                                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                                                    />
                                                </div>
                                            ))
                                        ) : (
                                            <p>No hay archivos disponibles</p>
                                        )}
                                    </div>
                                </div>
                                {status_item.some((item) => item.status === "Orden NO Asignada" && statusMotive != '') && (
                                    <div className="observaciones_div">
                                        <p>Motivo de No Asignación:</p>
                                        <textarea
                                            value={statusMotive}
                                            autoComplete="none"
                                            className="label_status pp_status_obs"
                                            readOnly
                                        />
                                    </div>
                                )}
                            </div>
                            {from === "CalendarDash" && (

                            <div className="modal-content-scroll">
                            <table className="responsive-table" style={{ marginBottom: 24 }}>
                                <thead>
                                    <tr>
                                        <th>N° de Solicitud</th>
                                        <th>Usuario</th>
                                        <th>Cliente</th>
                                        <th>Proveedor</th>
                                        <th>Categoría</th>
                                        <th>Monto</th>
                                        <th>Estado</th>
                                        <th>Entrega Estimada</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ProductCellOrder
                                        id={id}
                                        numero_orden={numero_orden}
                                        usuario={usuario}
                                        cliente={cliente}
                                        proveedor={proveedor}
                                        categoria={categoria}
                                        monto_total={monto_total}
                                        estado={estado}
                                        fecha_entrega={fecha_entrega}
                                        observaciones={observaciones}
                                        motivo_no_asignacion={motivo_no_asignacion}
                                        delay={delay}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                        disableRowClick={true}
                                        from="AnimatedModalOrder" 
                                    />
                                </tbody>
                            </table>
                        </div>
                        )}
                        </>
                    )}
                </div>
            </Fade>
        </Modal>
    );
}